<template>
  <div class="insights-ia-actions">
    <F360Button
      v-if="showViewReport"
      filled
      prefix-icon="search"
      @click="emit('viewReport')"
    >
      Ver relatório
    </F360Button>

    <F360Button
      v-if="showExport"
      outlined
      prefix-icon="file_download"
      :disabled="exportDisabled"
      :loading="exportLoading"
      @click="emit('exportData')"
    >
      Exportar dados do DRE
    </F360Button>
  </div>
</template>

<script setup lang="ts">
import F360Button from "@/ui/components/Buttons/Button/F360Button.vue";

withDefaults(
  defineProps<{
    showViewReport?: boolean;
    showExport?: boolean;
    exportDisabled?: boolean;
    exportLoading?: boolean;
  }>(),
  {
    showViewReport: true,
    showExport: true,
    exportDisabled: false,
    exportLoading: false
  }
);

const emit = defineEmits<{
  viewReport: [];
  exportData: [];
}>();
</script>

<style scoped lang="scss">
.insights-ia-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
